import { ROUTES } from "constants/routes";
import { Navigate } from "react-router-dom";

const isAuthenticated = () => Boolean(localStorage.getItem("token"));

export const RequireAuth = ({ children }: { children: React.ReactNode }) =>
  isAuthenticated() ? (
    <>{children}</>
  ) : (
    <Navigate replace to={ROUTES.LOGIN.path} />
  );

export const RedirectIfAuthed = ({ children }: { children: React.ReactNode }) =>
  isAuthenticated() ? (
    <Navigate replace to={ROUTES.DASHBOARD.path} />
  ) : (
    <>{children}</>
  );
